import React, { useEffect, useState } from 'react'
import { Form, Select } from 'antd'
import { StoreType } from './types'
import { filterSelectOption } from 'packages/@slerp/antd-utils'
import { nonEmptySelectRule } from './Rules'

interface StoreSwitchOption {
  children: string
  key: string
  value: string
}

type Props = {
  form: any
  stores: StoreType[]
  defaultValue: string[]
}

const LoyaltyStoreSelect = ({ form, stores, defaultValue }: Props) => {
  const [storeIdFilter, setStoreIdFilter] = useState<string[]>(defaultValue)

  useEffect(() => {
    form.setFieldsValue({ store_ids: storeIdFilter })
  }, [storeIdFilter])

  const onSelectHandler = (value: string) => {
    const store_ids = stores.map((store: StoreType) => store.id)
    if (
      value === 'all' ||
      (storeIdFilter.length === store_ids.length &&
        storeIdFilter.every((v) => store_ids.includes(v)))
    ) {
      setStoreIdFilter([...store_ids, 'all'])
      return
    }

    setStoreIdFilter((prev) => [...prev, value])
  }

  const onDeselectHandler = (value: string) => {
    if (value === 'all') {
      setStoreIdFilter([])
      return
    }

    setStoreIdFilter((prev) => prev.filter((p) => p !== value))
  }

  return (
    <React.Fragment>
      <Form.Item
        label='Valid stores'
        name='store_ids'
        rules={nonEmptySelectRule}
      >
        <Select
          allowClear
          data-testid='stores-filter-dropdown'
          placeholder='Select More Stores'
          onDeselect={onDeselectHandler}
          onSelect={onSelectHandler}
          filterOption={(input: string, option: StoreSwitchOption) =>
            filterSelectOption(input, option)
          }
          tagRender={({ value, label, onClose }) => {
            if (value === 'all') return <></>

            return (
              <div
                className='ant-select-selection-overflow-item'
                style={{ opacity: '1' }}
              >
                <span className='ant-select-selection-item'>
                  <span className='ant-select-selection-item-content'>
                    {label}
                  </span>
                  <span
                    className='ant-select-selection-item-remove'
                    unselectable='on'
                    aria-hidden='true'
                    style={{ userSelect: 'none' }}
                  >
                    <span
                      role='img'
                      aria-label='close'
                      className='anticon anticon-close'
                      onClick={onClose}
                    >
                      <svg
                        viewBox='64 64 896 896'
                        focusable='false'
                        data-icon='close'
                        width='1em'
                        height='1em'
                        fill='currentColor'
                        aria-hidden='true'
                      >
                        <path d='M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'></path>
                      </svg>
                    </span>
                  </span>
                </span>
              </div>
            )
          }}
          value={storeIdFilter}
          mode='multiple'
          dropdownClassName='select-multiple'
        >
          <Select.Option
            value='all'
            key={'all'}
            className='_px-8 _my-2'
            data-testid='location-option-all'
          >
            All stores
          </Select.Option>
          {stores.map((store: StoreType) => (
            <Select.Option
              value={store.id}
              key={store.id}
              className='_px-8 _my-2'
              data-testid={`stores-filter-by-store-${store.name}`}
            >
              {store.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </React.Fragment>
  )
}

export default LoyaltyStoreSelect
